import { Col, Radio, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import "./style.css";
import TextArea from "antd/lib/input/TextArea";
import CustomPrimaryButton from "../../../../../components/d-reusable/CustomPrimaryButton";
import CustomDefaultButton from "../../../../../components/d-reusable/CustomDefaultButton";
import { _quadrants } from "../../../../../../helper";
import { useDispatch, useSelector } from "react-redux";
import {
  _onAddQuadrantObservation,
  _onAddToothObservation,
  _onRecordUpdate,
  _updateQuadrantObservation,
  _updateToothObservation,
} from "../../../../../../redux/actions/dentalRecordAction";

const { Option } = Select;

const AddObservation = ({ onCancel, onAdd, observationData }) => {
  const dispatch = useDispatch();
  const markedTeeth = useSelector((state) => state.dental?.markedTeeth || []);
  const quadrantData = useSelector((state) => state.dental?.quadrants || []);
  const tempTeeth = useSelector((state) => state.dental?.tempTeeth || []);
  const tempQuadrant = useSelector((state) => state.dental?.tempQuadrant || []);
  const isRecordUpdate = useSelector(
    (state) => state.dental?.isRecordUpdate || false
  );

  const isTeethSelection = tempTeeth.length > 0;
  const [erros, setErros] = useState({
    observation: "",
  });

  const [values, setValues] = useState({
    observation: "",
  });

  useEffect(() => {
    // Find the selected tooth or quadrant based on the editingId
    const selectedTooth = markedTeeth.find(
      (item) => item.tooth_id === observationData?.id
    );
    const selectedQuadrant = quadrantData.find(
      (item) => item.identifier === observationData?.identifier
    );

    if (selectedTooth) {
      setValues({
        observation: selectedTooth.observation,
      });
    } else if (selectedQuadrant) {
      setValues({
        observation: selectedQuadrant.observation,
      });
    }
  }, [markedTeeth, quadrantData, observationData]);

  const handleAddObservation = () => {
    if (values.observation === "") {
      setErros({
        ...erros,
        observation: "This field is required",
      });
      return;
    }

    // Handle add or update logic for observation
    if (!isRecordUpdate) {
      // If we are ADDING a new observation
      if (isTeethSelection) {
        console.log("Adding new tooth observation");
        dispatch(_onAddToothObservation(values.observation));
      } else {
        console.log("Adding new quadrant observation");
        dispatch(_onAddQuadrantObservation(values.observation));
      }
    } else {
      // If we are UPDATING an existing observation
      if (isTeethSelection) {
        console.log("Updating tooth observation");
        dispatch(
          _updateToothObservation(observationData?.id, values.observation)
        );
      } else {
        console.log("Updating quadrant observation");
        dispatch(
          _updateQuadrantObservation(
            observationData?.identifier,
            values.observation
          )
        );
      }
    }

    // Reset the observation field and update state
    setValues({
      observation: "",
    });

    // Set record update flag to false
    dispatch(_onRecordUpdate(false));

    // Trigger onAdd action (presumably to close modal or reset state)
    onAdd();
  };

  return (
    <div className="d_add_observation_container">
      <div className="d_add_observation_body">
        <div className="d_add_observation_entry">
          <p>Add Ovservation</p>
          <TextArea
            placeholder="Add Here"
            value={values?.observation}
            onChange={(e) =>
              setValues({ ...values, observation: e.target.value })
            }
            onFocus={() => setErros({ ...erros, observation: "" })}
          />
          {erros?.observation && (
            <p className="custom_error">{erros.observation}</p>
          )}
        </div>
        <div className="d_add_observation_actions">
          <CustomPrimaryButton onClick={handleAddObservation} title="Save" />
          <CustomDefaultButton onClick={onCancel} title="Cancel" />
        </div>
      </div>
    </div>
  );
};

export default AddObservation;
